import React from 'react';
import { UserSystemGroup } from 'store/storeTypes';
import DesktopDtfTopCards from './DesktopDtfTopCards';
import DesktopDtgTopCards from './DesktopDtgTopCards';
import DesktopApolloTopCards from './DesktopApolloTopCards';
import { ITopCardsProps } from './TopCardsContainer';

const DesktopTopCards = (props: ITopCardsProps) => {
  const { selectedSystemGroup } = props;
  if (UserSystemGroup.DTF === selectedSystemGroup) {
    return <DesktopDtfTopCards {...props} />;
  }
  if (UserSystemGroup.Apollo === selectedSystemGroup) {
    return <DesktopApolloTopCards {...props} />;
  }
  return <DesktopDtgTopCards {...props} />;
};

export default DesktopTopCards;
